import { StepKey } from 'enums/steps';

export const API_GET_LOCALIZATION_BUNDLE = '/localization/bundle';

export const DEFAULT_LANGUAGE_CODE = 'en';

export const I18N_DEFAULT_NAMESPACE = 'translation';

export const UNSECURED_VA_ELIGIBILITY_PROMPT_KEY = 'pos.step.vaEligibility.unsecured.prompt';

// The server-provided VA step title is written for mortgage flows (VA loan framing);
// unsecured loans reuse the step but only offer a veteran rate discount.
export const UNSECURED_VA_ELIGIBILITY_PROMPT_FALLBACK =
  'Are any of the borrowers a veteran or active-duty service member? Veterans may qualify for a discounted rate on this loan.';

export const STEP_LOCALIZATION_KEY_SEGMENT: Partial<Record<StepKey, string>> = {
  [StepKey.TypeOfLoan]: 'typeOfLoan',
  [StepKey.VaEligibility]: 'vaEligibility',
  [StepKey.PropertyType]: 'propertyType',
  [StepKey.PropertyUsageDetails]: 'propertyUsageDetails',
  [StepKey.PropertyAddress]: 'propertyAddress',
  [StepKey.PropertyValue]: 'propertyValue',
  [StepKey.PurposeOfRefinance]: 'purposeOfRefinance',
  [StepKey.FirstTimeHomeBuyer]: 'firstTimeHomeBuyer',
  [StepKey.CurrentMortgageBalance]: 'currentMortgageBalance',
  [StepKey.CurrentCreditProfile]: 'currentCreditProfile',
  [StepKey.PersonalInfo]: 'personalInfo',
  [StepKey.RateComparison]: 'rateComparison',
  [StepKey.FullPersonalInfo]: 'fullPersonalInfo',
  [StepKey.CreditProfile]: 'creditProfile',
  [StepKey.PropertyInformation]: 'propertyInformation',
  [StepKey.TitleHolder]: 'titleHolder',
  [StepKey.ResidenceInfo]: 'residenceInfo',
  [StepKey.Reo]: 'reo',
  [StepKey.Income]: 'income',
  [StepKey.Assets]: 'assets',
  [StepKey.Declarations]: 'declarations',
  [StepKey.PropertyAndLoan]: 'propertyAndLoan',
  [StepKey.YourFinances]: 'yourFinances',
  [StepKey.MilitaryServices]: 'militaryServices',
  [StepKey.HomeownershipEducationAndHousingCounseling]: 'homeownershipEducation',
  [StepKey.LanguagePreferences]: 'languagePreferences',
  [StepKey.DemographicInformation]: 'demographicInformation',
  [StepKey.Review]: 'review',
  [StepKey.CashOutAmount]: 'cashOutAmount',
  [StepKey.FinalRateComparison]: 'finalRateComparison',
  [StepKey.DeclarationsGeneral]: 'declarationsGeneral',
  [StepKey.AdditionalQuestions]: 'additionalQuestions',
  [StepKey.PurchaseProcessType]: 'purchaseProcessType',
  [StepKey.PurchasePrice]: 'purchasePrice',
  [StepKey.DownPayment]: 'downPayment',
  [StepKey.DownPaymentSource]: 'downPaymentSource',
  [StepKey.PurchaseLocation]: 'purchaseLocation',
  [StepKey.Budget]: 'budget',
  [StepKey.WorkingWithRealtor]: 'workingWithRealtor',
  [StepKey.RealtorInLoop]: 'realtorInLoop',
  [StepKey.RealtorInfo]: 'realtorInfo',
  [StepKey.AdditionalLoanHelocHighBalance]: 'additionalLoanHelocHighBalance',
  [StepKey.AdditionalLoanHelocExistingMortgage]: 'additionalLoanHelocExistingMortgage',
  [StepKey.AdditionalLoanHomeEquityCreditPurpose]: 'additionalLoanHomeEquityCreditPurpose',
  [StepKey.UnsecuredLoanPurpose]: 'unsecuredLoanPurpose',
};
